module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image15.65f00ab1.jpg";